import { Component, OnInit } from '@angular/core';

import { ScreenService } from '../services/screen.service';

@Component({
    selector: 'fw-content',
    template: require('./content.component.html'),
    styles: [require('./content.component.css')]
})
export class ContentComponent implements OnInit {

    constructor(private screenService: ScreenService) { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/content/content.component.ts